module.exports = __webpack_public_path__ + "static/media/Manual_Builder_Product_Angle.5d2fe8c7.png";